module.exports = __webpack_public_path__ + "static/media/0_2018_11_28.470c83e2.jpg";